// Header.js
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CMSBlock from "components/cms/CMSBLock";
import './footer.css';
const Header = React.memo(() => {
  const user = useSelector((state) => state.user);
  const config = useSelector((state) => state.config);
  const { t } = useTranslation();
  return (
    <footer id="app-footer" className='py-3'>
      <div id="footer-main">
        <div className='container-fluid d-flex flex-column flex-md-row'>
          <div className='flex-grow-1 pe-md-2 text-center text-md-start' id='footer-left'>
            <CMSBlock
              blockId="footer-left"
            />
          </div>
          <div className='flex-grow-1 px-md-2 text-center' id='footer-center'>
            <CMSBlock
              blockId="footer-center"
            />
          </div>
          <div className='flex-grow-1 ps-md-2  text-center text-md-end' id='footer-right'>
            <CMSBlock
              blockId="footer-right"
            />
          </div>
        </div>
      </div>
    </footer>
  );
});
export default React.memo(Header);
